/** Zahlen deutsch: „300,00 m²", „3,3 h", „×1,00". Bis 08.10.2026 stand an
 *  mehreren Stellen `toFixed` — und damit der Punkt (Testlauf 06.10.2026). */
export function zahl(n: number | string | null | undefined, stellen?: number): string {
  if (n === null || n === undefined || n === "") return "—";
  const wert = Number(n);
  if (!Number.isFinite(wert)) return String(n);
  return wert.toLocaleString("de-DE", stellen === undefined
    ? { maximumFractionDigits: 2 }
    : { minimumFractionDigits: stellen, maximumFractionDigits: stellen });
}

/** „2026-10-15" → „15.10.2026". */
export function datumDe(iso: string | null | undefined): string {
  if (!iso) return "";
  const [j, m, t] = String(iso).slice(0, 10).split("-");
  return t && m && j ? `${t}.${m}.${j}` : String(iso);
}

const MONATE_LANG = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August",
  "September", "Oktober", "November", "Dezember"];

/** „2026-10" → „Oktober 2026". Rohdatum stand bis 09.10.2026 auf der Zahlungsseite. */
export function periodeDe(periode: string | null | undefined): string {
  if (!periode) return "";
  const [j, m] = String(periode).split("-");
  const name = MONATE_LANG[Number(m) - 1];
  return name && j ? `${name} ${j}` : String(periode);
}
